<script setup>
import router from '@/router';
import InputField from '@/components/InputField.vue';

import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';

defineOptions({
  name: 'TherapyView',
});

const props = defineProps({
  therapy_id: {
    type: Number,
    required: true,
  },
});

const store = useStore();
const therapistName = computed(() => store.getters.therapistName);
let isLoading = ref(false);

const label = ref(`praat tegen ${therapistName.value}`);
const showSystemMsg = ref(false);
const input = ref('');
const selectedRole = ref('user');
const onInputUpdate = async (val) => {
  input.value = val;
};
const stripTime = (date) => {
  return new Date(date).toLocaleDateString();
};
const stripDate = (date) => {
  if (!date) return Date.toLocaleTimeString();
  return new Date(date).toLocaleTimeString();
};

const sendMessage = async () => {
  isLoading.value = true;

  if (input.value != '') {
    store.commit('addTherapyViewMessage', {
      therapy_id: props.therapy_id,
      role: selectedRole.value,
      content: input.value,
    });
  }

  try {
    const response = await store.dispatch('post', {
      end_point: 'therapy',
      path_vars: {
        therapy_id: props.therapy_id,
      },
      body_vars: {
        role: selectedRole.value,
        content: input.value,
      },
    });

    //choices":[{"message":{"role":"assistant","content":"HTML is a markup language used for creating web pages, while XML is a markup language used for storing and transporting data. \n\nHTML is designed to display information on a web page, while XML is designed to store and transport data between different systems. HTML has a predefined set of tags that define the structure and content of a web page, while XML allows the user to define their own tags and structure to suit their specific needs.\n\nHTML is more forgiving than XML when it comes to syntax errors, as it is designed to be easily parsed by web browsers. XML, on the other hand, requires strict adherence to syntax rules to be parsed correctly.\n\nIn summary, HTML is used for displaying information, while XML is used for storing and transporting data between different systems."},"finish_reason":"stop","index":0}]}

    /*str.match(/.*?(?=<\/a>|$)/i)[0]
        This means: match zero-or-more character lazily, until reaching a </a> or end of string.

        Note that *? is a single operator, (.*)? is not the same as .*?.

        */

    if (!response || !response.data || selectedRole.value == 'system') {
      input.value = '';
      isLoading.value = false;
      return;
    }
    const { content, role } = response.data;
    //dit is de reactie van de server, dus 'assistant'

    store.commit('addTherapyViewMessage', {
      therapy_id: props.therapy_id,
      role,
      content,
    });
  } catch (error) {
    store.dispatch('modal/setModal', {
      title: 'Completion error',
      text: error.message,
      type: 'notification',
    });
  }
  input.value = '';
  isLoading.value = false;
};

const toggleSystemMsg = () => {
  showSystemMsg.value = !showSystemMsg.value;
};
const htmlResponse = (content) => {
  if (content == null) return '';
  return content
    .replace(/(\\n\\n\d+).*?(?=\\n|$)/g, '<li>')
    .replace(/\\n/g, '<br>');
};

onMounted(async () => {
  const messages = await store.dispatch('get', {
    end_point: 'therapy',
    path_vars: {
      therapy_id: props.therapy_id,
    },
  });
  store.commit('setTherapyViewMessages', {
    therapy_id: props.therapy_id,
    messages,
  });
});

const closeTherapy = async () => {
  // dit loopt NIET via een socket!
  router.push({ name: `TherapyMenu` });
};

const messages = computed(() => {
  return store.getters.therapyViewMessages(props.therapy_id);
});
const keydown = (event) => {
  event.preventDefault();
  event.stopPropagation();
  sendMessage();
};
</script>
<template>
  <div class="full">
    <h1 class="title is-size-3-mobile is-size-2-tablet">
      TherapyView {{ therapy_id }}
    </h1>

    <div class="field">
      <div class="control">
        <button class="button is-danger" @click="closeTherapy">
          naar menu
        </button>
      </div>
    </div>

    <input-field
      :label="label"
      :is-input="false"
      :maxlength="256"
      :default-value="selectedRole == 'user' ? 'say something in spanish' : ''"
      :placeholder="'say something'"
      :read-only="false"
      @inputupdate="onInputUpdate"
      @keydown="keydown"
    ></input-field>

    <div class="field">
      <label class="label">rolkeuze:</label>
      <div class="control">
        <label class="radio">
          <input type="radio" name="role" value="user" v-model="selectedRole" />
          user
        </label>
        <label class="radio">
          <input
            type="radio"
            name="role"
            value="system"
            v-model="selectedRole"
          />
          system
        </label>
      </div>
    </div>
    <div class="field">
      <div class="control">
        <button
          class="button is-small"
          :disabled="isLoading"
          :class="isLoading ? 'is-loading' : ''"
          @click="sendMessage"
        >
          <span>verzend</span>
        </button>
      </div>
    </div>

    <div class="field">
      <div class="control">
        <button
          class="button is-small"
          :disabled="isLoading"
          :class="isLoading ? 'is-loading' : ''"
          @click="toggleSystemMsg"
        >
          <span>toggle system</span>
        </button>
      </div>
    </div>

    <div
      v-if="therapy_id != null && messages && messages.length != 0"
      class="content"
    >
      <br />
      <p><b>datum:</b> {{ stripTime(messages[0].timestamp) }}</p>
      <table class="table is-bordered is-narrow is-fullwidth">
        <template v-for="(message, index) in messages">
          <tr
            :key="index"
            class="trview"
            :class="message.role"
            v-if="showSystemMsg ? true : message.role !== 'system'"
          >
            <td>
              <b>{{ message.role }}</b>
            </td>
            <td>{{ stripDate(message.timestamp) }}</td>
            <td v-html="htmlResponse(message.content)"></td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>
<style lang="scss" scoped></style>
